export enum FibuExportType {
  ES = 'ES',
  DATEV = 'DATEV',
}

export enum FibuExportByType {
  FINANCIAL_CLAIM = 'FINANCIAL_CLAIM',
  PAYMENT = 'PAYMENT',
}
